var _g, _circle, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTiktok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_936_3360)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.5921 11.6569C28.5935 12.023 28.7004 17.3137 34.2528 17.6437C34.2528 19.1695 34.2546 20.2758 34.2546 21.7317C33.8342 21.7561 30.5993 21.5212 28.586 19.7255L28.5799 27.6839C28.6564 33.2077 24.5914 36.5691 19.2781 35.408C10.1159 32.6672 13.1604 19.0781 22.3601 20.5327C22.3601 24.9197 22.3624 20.5312 22.3624 24.9197C18.5618 24.3605 17.2906 27.5222 18.3007 29.7858C19.2195 31.8469 23.0037 32.2936 24.3237 29.3859C24.4732 28.8169 24.5478 28.1681 24.5478 27.4397V11.6367L28.5921 11.6569Z",
    fill: "white"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 23.5,
    stroke: "#5D5D5D"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_936_3360"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(12 11.6367)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/tiktok.b95f7167823aa077d928d9d2d4bb1d25.svg";
export { ForwardRef as ReactComponent };